import React, { useEffect, useState } from "react";
import axios from "axios";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { FiArrowLeft, FiCalendar, FiClock } from "react-icons/fi";
import { useBaseUrl } from "../../../context/AppContext";
import { checkLoggedInCustomer } from "../../../helper/CustomHelper";
import "../../../assets/css/customer/dashboard/MyTreatmentDetail.css";

const formatTime = (time) => {
  if (!time) return "";
  const [h, m] = time.split(":");
  const hour = parseInt(h, 10);
  const suffix = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 || 12;
  return `${String(hour12).padStart(2, "0")}:${m} ${suffix}`;
};

const MyTreatmentDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFile } = useBaseUrl();

  const [appointment, setAppointment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    checkLoggedInCustomer(navigate);

    axios
      .get(`${baseUrl}/customer/appointment/completedTreatmentDetail`, {
        params: {
          id,
          escustomer_id: localStorage.getItem("customerId"),
        },
      })
      .then((res) => setAppointment(res.data?.data || null))
      .catch((err) =>
        setError(err.response?.data?.message || "Unable to load treatment.")
      )
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return (
      <div className="sgc-treat-detail-center">
        <Spinner animation="border" />
      </div>
    );
  }

  if (error || !appointment) {
    return (
      <div className="sgc-treat-detail-center">
        <p>{error || "Treatment not found."}</p>
        <button
          className="sgc-treat-detail-back"
          onClick={() => navigate("/customer/treatments")}
        >
          <FiArrowLeft /> Back to My Treatments
        </button>
      </div>
    );
  }

  const treatment = appointment.estreatment || {};

  return (
    <div className="sgc-treat-detail-page">
      <Container fluid>
        <button
          className="sgc-treat-detail-back"
          onClick={() => navigate("/customer/treatments")}
        >
          <FiArrowLeft /> Back to My Treatments
        </button>

        <div className="sgc-treat-detail-card">
          <Row className="g-4">
            <Col lg={5} md={12}>
              <img
                src={`${baseUrlForFile}/${treatment.image}`}
                alt={treatment.title}
                className="sgc-treat-detail-img"
              />
            </Col>

            <Col lg={7} md={12}>
              <span className="sgc-treat-detail-badge">Completed</span>

              <h1 className="sgc-treat-detail-title">{treatment.title}</h1>

              <div className="sgc-treat-detail-meta">
                <span>
                  <FiCalendar /> {appointment.appointment_date}
                </span>
                <span>
                  <FiClock /> {formatTime(appointment.appointment_time)}
                </span>
              </div>

              <h5 className="sgc-treat-detail-heading">About this treatment</h5>
              <p className="sgc-treat-detail-desc">{treatment.description}</p>

              {appointment.notes && (
                <>
                  <h5 className="sgc-treat-detail-heading">Your notes</h5>
                  <p className="sgc-treat-detail-desc">{appointment.notes}</p>
                </>
              )}

              <button
                className="sgc-treat-btn-book"
                onClick={() => navigate("/customer/book")}
              >
                Book Again
              </button>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default MyTreatmentDetail;